import { useState, useEffect, useCallback } from 'react'
import { supabase } from '../lib/supabase'

// Append-only record of superadmin actions in HQ (admin_audit_log table).
// log() is fire-and-forget and a no-op for non-superadmins or before the
// comped_audit_migration has run.
export function useAuditLog(currentUser) {
  const isSuper = currentUser?.role === 'superadmin'
  const [entries, setEntries] = useState([])

  const fetchEntries = useCallback(async () => {
    const { data } = await supabase
      .from('admin_audit_log').select('*')
      .order('created_at', { ascending: false }).limit(25)
    setEntries((data || []).map((r) => ({
      id: r.id,
      actorName: r.actor_name,
      action: r.action,
      target: r.target,
      details: r.details,
      createdAt: r.created_at ? new Date(r.created_at) : null,
    })))
  }, [])

  useEffect(() => { if (isSuper) fetchEntries() }, [isSuper, fetchEntries])

  const log = useCallback((action, target = '', details = null) => {
    if (!isSuper) return
    supabase.from('admin_audit_log').insert({
      actor_id: currentUser.id,
      actor_name: currentUser.name || '',
      action,
      target,
      details,
    }).then(({ error }) => { if (!error) fetchEntries() }, () => {})
  }, [isSuper, currentUser?.id, currentUser?.name, fetchEntries])

  return { entries, log, fetchEntries }
}
